import { render } from "./HeroiconsSolidPhoneMissedCall.vue?vue&type=template&id=6b904d2b"
const script = {}

import exportComponent from "C:\\laragon\\www\\idmex-api\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPhoneMissedCall.vue"]])

export default __exports__